import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Menu, Input, Button, Typography } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, SearchOutlined, LogoutOutlined } from '@ant-design/icons';
import { MenuList } from './nav/MenuList';
import logo from '../../logo.svg';

const { Text } = Typography;

export default function Sidebar({ collapsed, setCollapsed, isMobile, setIsMobile }) {
    const [searchValue, setSearchValue] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const checkMobile = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (mobile) setCollapsed(true);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, [setCollapsed, setIsMobile]);

    const toggleCollapsed = () => setCollapsed(!collapsed);

    const filterMenuItems = (items, searchText) => {
        if (!searchText) return items;

        return items.filter(item => {
            const matches = item.label.toLowerCase().includes(searchText.toLowerCase());
            if (item.children) {
                const filteredChildren = filterMenuItems(item.children, searchText);
                return matches || filteredChildren.length > 0;
            }
            return matches;
        }).map(item => {
            if (item.children) {
                return {
                    ...item,
                    children: filterMenuItems(item.children, searchText)
                };
            }
            return item;
        });
    };

    const formatMenuItems = (items, isRoot = true) => {
    const formattedItems = items.map(item => ({
        key: item.key,
        icon: item.icon,
        label: item.label,
        children: item.children ? formatMenuItems(item.children, false) : undefined,
        onClick: !item.children ? () => navigate(item.to) : undefined,
    }));

    if (isRoot) {
        formattedItems.push({
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Logout',
            onClick: () => {
                console.log('logout');
                // Cookies.remove('authToken');
                // localStorage.removeItem('authToken');
                window.location.reload();
            },
        });
    }

    return formattedItems;
};

    const filteredMenuItems = useMemo(() => {
        const filtered = filterMenuItems(MenuList, searchValue);
        return formatMenuItems(filtered);
    }, [MenuList, searchValue]);

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        }}>
            {/* Fixed header */}
            <div style={{
                padding: 16,
                borderBottom: '1px solid rgba(243, 15, 15, 0.1)',
                flexShrink: 0
            }}>
                {!collapsed ? (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <img
                                src={logo}
                                alt="Logo"
                                style={{ width: '200px', height: 'auto' }}
                                onClick={toggleCollapsed}
                            />
                            {/* <Text strong style={{ color: 'rgba(185, 37, 37, 0.95)', fontSize: '1.25rem' }}>
                                Logo or app title
                            </Text> */}
                        </div>
                       
                    </div>
                ) : (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            type="text"
                            icon={<MenuUnfoldOutlined style={{ color: 'rgba(185, 37, 37, 0.95)e' }} />}
                            onClick={toggleCollapsed}
                            style={{ width: 40, height: 40 }}
                        />
                    </div>
                )}
            </div>

            {/* Search (only when expanded) */}
            {!collapsed && (
                <div style={{
                    padding: 12,
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    flexShrink: 0
                }}>
                    <Input
                        placeholder="Search menu..."
                        prefix={<SearchOutlined style={{ color: 'white' }} />}
                        style={{
                            backgroundColor: 'rgba(162, 162, 163, 0.39)',
                            border: '1px solid rgba(255, 255, 255, 0.71)',
                            color: 'rgba(120, 30, 30, 0.71)',
                            borderRadius: '4px',
                        }}
                        value={searchValue}
                        onChange={handleSearchChange}
                        allowClear
                        // Add this for placeholder styling
                        classNames={{
                            input: 'white-placeholder'
                        }}
                    />

                </div>
            )}

            {/* Scrollable menu */}
            <div
                style={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden'
                }}
            >
                <Menu
                    theme="light"
                    mode="inline"
                    style={{ borderRight: 0, color: '#e0e0e0', background: '#e0e0e0' }}
                    items={filteredMenuItems}
                    className="white-text-with-stroke"
                />
            </div>
        </div>
    );
}